export default __webpack_public_path__ + "static/media/link_twitter.a8001a07.svg";